module.exports = __webpack_public_path__ + "static/media/mode-2042.08553ee8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2042.svg
// module id = 1035
// module chunks = 2